<template>
  <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.5 13.8651C9.5 10.5551 12.19 7.86513 15.5 7.86513C16.59 7.86513 17.62 8.16513 18.5 8.67513V7.86513L16.42 1.86513C16.22 1.28513 15.66 0.865128 15 0.865128H4C3.34 0.865128 2.78 1.28513 2.58 1.86513L0.5 7.86513V15.8651C0.5 16.4151 0.95 16.8651 1.5 16.8651H2.5C3.05 16.8651 3.5 16.4151 3.5 15.8651V14.8651H9.59C9.54 14.5351 9.5 14.2051 9.5 13.8651ZM4 2.36513H15L16.5 6.86513H2.5L4 2.36513ZM4 11.8651C3.17 11.8651 2.5 11.1951 2.5 10.3651C2.5 9.53513 3.17 8.86513 4 8.86513C4.83 8.86513 5.5 9.53513 5.5 10.3651C5.5 11.1951 4.83 11.8651 4 11.8651ZM16.42 10.8651V12.8651H17.5H18.5V14.8651H16.5V16.8651H14.5V14.8651H12.5V12.8651H14.5V10.8651H16.42Z"  class="icon-fill" />
  </svg>
</template>

<script>
export default {
  name: 'car_plus'
}
</script>
<style lang="css">
.icon-fill {
  fill: currentColor;
}
</style>